import React, { useEffect, useState } from 'react';
import './AssetEditContent.scss'; // Import your CSS file for styling
import PdfPreview from 'componentsV2/PDFPreview/PdfPreview';
import MetadataEdit from './MetadataEdit';
import { MetadataElement, MetadataElementList, TableData } from 'componentsV2/AssestUpload/SingleUpload/SingleUploadModel';
import ActionButton from 'componentsV2/AssestUpload/BulkUpload/ActionButton';
import { useDispatch, useSelector } from 'react-redux';
import submitValidation from 'actions/submitValidation';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { assetUploadService } from 'api/assetUploadService';
import AlertBox from 'componentsV2/SharedAlertBox/AlertBox/AlertBox';
import { singleUploadActions } from 'actions/singleUpload';
import { useNavigate } from 'react-router';
import { HOME_PAGE } from 'constants/routes';
import { findElementByPrompt } from 'utils/utils';
interface AssetEditContentProps {
  assetDetails: any;
  assetId: string;
}

const AssetEditContent: React.FC<AssetEditContentProps> = ({ assetDetails,assetId }) => {
  const {userName} = useSelector((state:any) => state.userTypeReducer?.userType?.data) || {};
  const [leftWidth, setLeftWidth] = useState(53); // Initial width of the left section (percentage)
  const [isDragging, setIsDragging] = useState(false); // State to track dragging
  const [responseAlert, setResponseAlert] = useState({
    isOpen: false,
    inputProps: {success: false},
    message: ''
  });
  const MAX_LEFT_WIDTH = 60; // Maximum width for the left section (percentage)
  const MIN_LEFT_WIDTH = 20; // Minimum width for the left section (percentage)
  const [tableData, setTableData] = useState<TableData[]>([]);
  const singleUploadPayload = useSelector(
    (state: any) => state.singleUpload.payload
  );
  const navigate = useNavigate();
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  // Function to generate tableData in the required format
  const generateTableData = () => {
    const metadataElementList =assetDetails?.metadata_collection?.metadata_element_list;
    if (!metadataElementList) {
      return;
    }

    const groupedData = metadataElementList.reduce(
      (acc: TableData[], category: MetadataElementList) => {
        const groupedByMetaTableId = category.metadata_element_list.reduce(
          (group: any, element: MetadataElement) => {
            if (element.is_tabular === 'Y' && element.meta_table_id) {
              if (!group[element.meta_table_id]) {
                group[element.meta_table_id] = [];
              }
              group[element.meta_table_id].push(element);
            }
            return group;
          },
          {}
        );

        Object.keys(groupedByMetaTableId).forEach((metaTableId) => {
          acc.push({
            name: category.id,
            meta_table_id: metaTableId,
            elements: groupedByMetaTableId[metaTableId]
          });
        });

        return acc;
      },
      []
    );
    setTableData(groupedData);
  };

  const shouldShowElement = (element: MetadataElement): boolean => {
    if (element.is_displayable === 'Y') {
      return true;
    }
    if (element.is_editable === 'Y') {
      return true;
    }
    return false; // Default return statement
  };

  // Generate tableData on component mount
  useEffect(() => {
    generateTableData();
  }, [assetDetails]);

  // Handle mouse down on the resizer
  const handleMouseDown = () => {
    setIsDragging(true);
  };

  

  // Handle mouse move to resize sections
  const handleMouseMove = (e: any) => {
    if (!isDragging) {
      return; // If not dragging, do nothing
    }

    // Calculate the new width of the left section
    const newLeftWidth = (e.clientX / window.innerWidth) * 100;

    // Restrict the width between MIN_LEFT_WIDTH and MAX_LEFT_WIDTH
    if (newLeftWidth >= MIN_LEFT_WIDTH && newLeftWidth <= MAX_LEFT_WIDTH) {
      setLeftWidth(newLeftWidth); // Update the width
    }
  };

  // Handle mouse up to stop dragging
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Add event listeners for mouse move and mouse up
  React.useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    }
    // remove the page scrollbar
    // document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

   
  const originalFilePath = findElementByPrompt(assetDetails, 'Original File Path'); // Replace with your logic to determine visibility

  const formattedSingleUploadPayload = () => {
    if (singleUploadPayload?.metadata_collection?.metadata_element_list) {
      singleUploadPayload.metadata_collection.metadata_element_list.forEach(
        (field: any) => {
          field.metadata_element_list.forEach((item: any) => {
            if(item.prompt === 'File Status'){
              item.value = { id: '2', display_value: 'Draft' }; // Update the value to Draft
            }
          });
        }
      );
    }
    const payload = JSON.parse(JSON.stringify(singleUploadPayload)); // Create a deep copy of the payload
    return payload;

  };
  const handleSubmit = async (event: any) => {
    event.preventDefault();
    // Handle form submission logic here
    const mandatoryFields = singleUploadPayload?.metadata_collection?.metadata_element_list.filter(
      (field: any) =>
        field.metadata_element_list.some(
          (item: any) => shouldShowElement(item) && item.is_required === 'Y'
        )
    );
    const requiredFields = mandatoryFields?.flatMap((field: any) =>
      field.metadata_element_list.filter((item: any) => {
        if (item?.value && !item.value.id?.trim() && item.is_required === 'Y') {
          return true;
        }
        return item?.values?.every((value: any) => value.id === '' && item.is_required === 'Y');
      })
    );

    if (requiredFields.length > 0) {
      // scroll to the first required field
      const firstRequiredField = document.getElementById(
        requiredFields[0].field_id
      );
      console.log('firstRequiredField', firstRequiredField);
      if (firstRequiredField) {
        window.scrollTo({
          top: firstRequiredField.offsetTop - 120,
          behavior: 'smooth'
        });
      }
      dispatch(submitValidation({ eventType: 'validate' }));
    } else {
      dispatch(submitValidation({ eventType: '' }));
      try {
        //update the field with prompt Name to first name and last name
        const payloadModified = formattedSingleUploadPayload();
        // Assuming singleUploadPayload is the payload you want to submit
        dispatch({ type: 'LOADING SUCCESS', payload: true });
        const formData = new FormData();
        formData.append('payload', JSON.stringify(payloadModified));
        const response = await assetUploadService
          .uploadAssets(formData, userName,assetId)
          .then((resp) => {
            return resp.json();
          });
        dispatch({ type: 'LOADING SUCCESS', payload: false });
        if (response?.asset_id?.length > 0) {
          setResponseAlert({
            isOpen: true,
            inputProps: {success: true},
            message:
              response?.message ||
              `Asset uploaded successfully with ID: ${response.asset_id.join(
                ', '
              )}`
          });
        }
        if (response?.error || response?.detail) {
          setResponseAlert({
            isOpen: true,
            inputProps: {success: false},
            message:
              response?.message || response?.detail ||
              'An error occurred while uploading the asset.'
          });
        }
      } catch (uploadError: any) {
        console.error('Error during asset upload:', uploadError);
        dispatch({ type: 'LOADING SUCCESS', payload: false });
        setResponseAlert({
          isOpen: true,
          inputProps: {success: false},
          message:
            uploadError?.message || 'An error occurred while uploading the asset.'
        });
      }
    }
  };

  const handleClose = () => {
    if(responseAlert?.inputProps?.success) {
      dispatch(singleUploadActions.clearSingleUploadPayload());
      dispatch(submitValidation({ eventType: '' }));
      navigate(HOME_PAGE);
    }
    setResponseAlert({
      isOpen: false,
      inputProps: {success: false},
      message: ''
    });
  };
  return (
    <>
      <div className="split-screen">
        {/* Left Section */}
        {originalFilePath?.value?.id && <div className="left-section" style={{ width: `${leftWidth}%` }}>
          <PdfPreview path={originalFilePath?.value?.id}/>
        </div>
        }

        {/* Resizer */}
        <div className="resizer" onMouseDown={handleMouseDown}></div>

        {/* Right Section */}
        <div className="right-section" style={{ width: !originalFilePath?.value?.id ? '100%' : `${100 - leftWidth}%` }}>
          {<MetadataEdit assetDetail={assetDetails} shouldShowElement={shouldShowElement} tableData={tableData} assetId={assetId} />}
        </div>
      </div>
      <ActionButton submitFile={handleSubmit} isDisabled={false}  />
      {responseAlert?.isOpen && (
        <AlertBox
          message={responseAlert.message}
          isModalOpen
          handleClose={handleClose}
        />
      )}
    </>
  );
};

export default AssetEditContent;
